import { Navigate } from 'react-router-dom';

function ProtectedRoute({
  isLoggedIn,
  children,
}: {
  isLoggedIn: boolean;
  children: React.ReactNode;
}) {
  if (!isLoggedIn) {
    return <Navigate to="/sign-in" />;
  }

  return children;
}

export default ProtectedRoute;
